import React from 'react'
import IconsAuraExp13 from './Images/IconsAuraExp13.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard13() {
  return (

    <>

    <div className='ExpPgCard '> 
        <p className='ExpPgHExpName'> Temple Festivals in South India </p>
        
        <p className='ExpPgHCat'> Festival </p>
        <p className='ExpPgHCode'> AURAMUSE113 </p>

        {/* <ButtExpAll /> */}
        
        {/* <img className='' src="" /> */}
      
          
          

          <div className='IconsAuraExpDiv'> <img className='IconsAuraExp' src={IconsAuraExp13} /> </div>

          <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>

    </>
    
  )

}


export default ExpCard13

